"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TemplateVariable = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _VariableType = require("../VariableType");
var _mustache = _interopRequireDefault(require("mustache"));
var _types = require("../../types");
class TemplateVariable extends _VariableType.VarsValueVariableType {
  constructor(...args) {
    super(...args);
    (0, _defineProperty2.default)(this, "settings", TemplateVariable.settings);
    (0, _defineProperty2.default)(this, "type", "template");
    (0, _defineProperty2.default)(this, "label", "Template");
    (0, _defineProperty2.default)(this, "description", "Turn a template into a variable.");
  }
  dependencies(params, resolver) {
    let template = resolver.resolveString(params.template);
    if (!template) {
      return {
        template,
        view: null
      };
    }
    let parsed = _mustache.default.parse(template);
    let layer = [...parsed];
    let variables = new Set();
    while (layer.length > 0) {
      let newLayer = [];
      for (let it of layer) {
        if (it[0] === "name" || it[0] === "#" || it[0] === "^") {
          let dot = it[1].indexOf(".");
          if (dot > 0) {
            variables.add(it[1].slice(0, dot));
          } else if (dot === -1) {
            variables.add(it[1]);
          }
          if (Array.isArray(it[4])) {
            newLayer = newLayer.concat(it[4]);
          }
        }
      }
      layer = newLayer;
    }
    let view = {};
    for (let it of variables) {
      let res = resolver.resolveVariable(it);
      view[it] = _types.vals.templateValue(res);
    }
    return {
      template,
      view
    };
  }
  value(deps) {
    let {
      template,
      view
    } = deps;
    if (template === "") {
      return "";
    }
    if (!template) {
      return null;
    }
    return _mustache.default.render(template, view);
  }
}
exports.TemplateVariable = TemplateVariable;
(0, _defineProperty2.default)(TemplateVariable, "settings", {
  template: {
    type: "editor",
    editor: "markdown",
    title: "Edit Template"
  }
});
//# sourceMappingURL=TemplateVariable.js.map